var _effectorFileName = "/builds/gmini/front-ui-kit/src/ResizableColumns/Panel/Panel.styled.tsx";
import { styled as muiStyled, Toolbar } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import styled from 'styled-components';
import { Typography } from '../../Typography';
import { SeparatorList as SeparatorListInit } from '../../SeparatorList';
import { jsx as _jsx } from "react/jsx-runtime";
export const PanelBody = muiStyled(({
  expanded,
  bodyStyles,
  ...other
}) => /*#__PURE__*/_jsx("div", { ...other
}))(props => ({
  position: 'relative',
  overflow: 'hidden',
  transition: props.theme.transitions.create('max-width'),
  flexGrow: 1,
  flex: '1',
  cursor: props.expanded ? 'default' : 'pointer',
  ...(props.expanded ? {
    maxWidth: '100%'
  } : {
    maxWidth: '48px'
  })
}));
export const PanelHeader = withStyles({
  root: ({
    noHeaderSeparator
  }) => ({
    borderBottom: noHeaderSeparator ? 'none' : '1px solid #E5E7F1',
    paddingLeft: '14px',
    paddingRight: '10px',
    minHeight: '40px',
    width: '100%'
  })
})(props => /*#__PURE__*/_jsx(Toolbar, { ...props
}));
export const PanelContent = muiStyled(({
  expanded,
  hideDN,
  hideVH,
  ...other
}) => /*#__PURE__*/_jsx("div", { ...other
}))(props => ({
  position: 'relative',
  display: props.hideDN ? 'none' : props.hideVH ? 'inline' : 'flex',
  flexDirection: 'column',
  transition: props.theme.transitions.create('transform'),
  transform: `translateX(${props.expanded ? 0 : 48}px)`,
  width: '100%',
  flex: 0,
  overflow: 'hidden',
  height: '100%',
  visibility: props.hideVH ? 'hidden' : 'initial'
}));
export const CollapsedHeader = muiStyled(Typography)(props => ({
  marginTop: props.theme.spacing(4),
  writingMode: 'vertical-lr',
  lineHeight: '48px'
}));
export const CollapsedBody = muiStyled(({
  expanded,
  ...other
}) => /*#__PURE__*/_jsx("div", { ...other
}))(props => ({
  transition: props.theme.transitions.create('transform'),
  transform: `translateX(${props.expanded ? -48 : 0}px)`,
  width: '48px',
  flex: 0,
  position: 'absolute'
}));
export const UnfoldMoreWrapper = styled.div`
  width: 32px;
  height: 32px;
  padding: 6px 10px;

  &:hover {
    background: rgba(53, 59, 96, 0.1);
  }

  &:active {
    & path {
      fill: #e1e1e9;
    }
  }
`;
export const FolderTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  transform: rotate(90deg);
  margin-top: 35px;
  letter-spacing: 0.15px;
  color: #616184;
  white-space: nowrap;
`;
export const PanelTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 30px;
  white-space: nowrap;
  letter-spacing: 0.15px;
  color: #353b60;
  margin-right: 4px;
  overflow-x: hidden;
`;
export const SeparatorList = styled(SeparatorListInit)`
  margin-left: auto;
`;